// selectors.js
import { createSelector } from 'reselect';

const dac7Selector = (state) => state.dac7;

export const getAvailableYears = createSelector(
  dac7Selector,
  (dac7) => dac7.availableYears,
);

export const getInfoByYear = createSelector(
  dac7Selector,
  (_, year) => year,
  (dac7, year) => dac7.info?.[year],
);

export const isLoading = createSelector(
  dac7Selector,
  (_, key) => key,
  (dac7, key) => dac7.isLoading?.[key],
);

export const error = createSelector(
  dac7Selector,
  (_, key) => key,
  (dac7, key) => dac7.error?.[key],
);
